import { useFormContext, Controller } from 'react-hook-form';
import { FormHelperText, OutlinedInput, Select, SelectProps } from '@mui/material';

type IProps = {
  name: string;
  label?: string;
  notched?: boolean;
  children: React.ReactNode;
};

type Props<T extends string | number> = IProps & SelectProps<T[]>;

const RHFMultipleSelect = <T extends string | number>(props: Props<T>) => {
  const { control } = useFormContext();

  const { name, children, notched, label, ...other } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref: fieldRef, ...fieldProps }, fieldState: { error } }) => (
        <>
          <Select
            {...fieldProps}
            multiple
            fullWidth
            inputRef={fieldRef}
            input={<OutlinedInput label={label} notched={notched} />}
            error={!!error && !fieldProps.value.length}
            {...other}
          >
            {children}
          </Select>

          {!!error && !fieldProps.value.length && (
            <FormHelperText error>{error.message}</FormHelperText>
          )}
        </>
      )}
    />
  );
};

export default RHFMultipleSelect;
